import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {SemanaProyecto, SemanasProyecto} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiProgService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** programacion ***/

  getProgramacion(curso: string, edad: string): Promise<SemanasProyecto[]> {
    const url = `${this.apiUrl}programacion/${curso}/${edad}`;
    return firstValueFrom(this.http.get<SemanasProyecto[]>(url))
  }
  getProgramacionTerminada(): Promise<SemanasProyecto[]> {
    const url = `${this.apiUrl}programacion/terminada`;
    return firstValueFrom(this.http.get<SemanasProyecto[]>(url))
  }
  getProgramacionSemana(tipo: string, semana: number, curso: string): Promise<SemanaProyecto[]> {
    const url = `${this.apiUrl}programacion/${curso}/${tipo}/${semana}`;
    return firstValueFrom(this.http.get<SemanaProyecto[]>(url))
  }
  getProgramacionByDate(tipo: string, fecha: string): Promise<SemanaProyecto> {
    const url = `${this.apiUrl}programacion/bydate/${tipo}/${fecha}`;
    return firstValueFrom(this.http.get<SemanaProyecto>(url))
  }
  getProgramacionSemanaCentro(centro: string, tipo: string, semana: number, curso: string): Promise<SemanaProyecto[]> {
    const url = `${this.apiUrl}programacion/${centro}/${curso}/${tipo}/${semana}`;
    return firstValueFrom(this.http.get<SemanaProyecto[]>(url))
  }
  getProgramacionCursos(): Promise<{curso: string}[]> {
    const url = `${this.apiUrl}programacion/cursos`;
    return firstValueFrom(this.http.get<{curso: string}[]>(url))
  }
  getProgramacionCentros(centros: string[]): Promise<SemanaProyecto[][]> {
    const url = `${this.apiUrl}programacion/centros`;
    return firstValueFrom(this.http.post<SemanaProyecto[][]>(url, centros))
  }
  toggleProgramacion(curso: string, edad: string, semana: number, terminado: boolean): Promise<any> {
    const url = `${this.apiUrl}programacion/toggle/${curso}/${edad}/${semana}/${terminado}`;
    return firstValueFrom(this.http.post<any>(url, {}))
  }
  saveProgramacion(datos: SemanaProyecto): Promise<any> {
    const url = `${this.apiUrl}programacion/nueva`;
    return firstValueFrom(this.http.put<any>(url, datos))
  }
  eliminarProgramacion(curso: string, edad: string, semana: number): Promise<any> {
    const url = `${this.apiUrl}programacion/${curso}/${edad}/${semana}`;
    return firstValueFrom(this.http.delete<any>(url))
  }

}
